import { css } from '@emotion/core';
export { filter } from './shared.style';
export var label = {
  name: "mgww5h",
  styles: "margin:0 0 10px;"
};